<template>
    <article
        v-show="payError != null"
        role="alert"
        class="error__alert"
        :class="errorStyle"
    >
        <span class="icon-wrapper">
            <svg
                preserveAspectRatio="xMidYMid meet"
                class="error__alert-icon"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 10 10"
            >
                <g clip-path="url(#a)">
                    <path
                        d="M4.658.388a4.658 4.658 0 1 0 0 9.317 4.658 4.658 0 0 0 0-9.317zm.97 7.22c-.24.094-.43.166-.574.216-.143.05-.309.074-.498.074-.29 0-.516-.07-.677-.213a.686.686 0 0 1-.24-.539c0-.084.005-.171.017-.26.012-.088.032-.187.058-.299l.3-1.06c.027-.102.05-.198.068-.288a1.28 1.28 0 0 0 .026-.25c0-.135-.028-.23-.083-.282-.057-.054-.163-.08-.32-.08a.841.841 0 0 0-.24.036 3.39 3.39 0 0 0-.208.07l.08-.327c.196-.08.384-.15.563-.206.18-.057.35-.086.509-.086.288 0 .51.07.667.21.156.138.234.32.234.542 0 .046-.005.127-.016.243-.01.116-.03.223-.06.32l-.298 1.057a2.988 2.988 0 0 0-.066.29c-.02.109-.029.191-.029.247 0 .14.031.236.094.287.063.05.172.077.327.077a1.404 1.404 0 0 0 .446-.105l-.08.325zm-.053-4.29a.712.712 0 0 1-.503.194.72.72 0 0 1-.505-.194.62.62 0 0 1-.21-.47c0-.184.071-.342.21-.473a.72.72 0 0 1 .505-.196c.196 0 .364.066.503.196.14.131.21.289.21.472 0 .184-.07.341-.21.47z"
                        fill="#EB5757"
                    />
                </g>
                <defs>
                    <clipPath id="a">
                        <path
                            fill="#fff"
                            transform="translate(0 .388)"
                            d="M0 0h9.317v9.317H0z"
                        />
                    </clipPath>
                </defs>
            </svg>
        </span>
        <p>
            {{ translateError() }}
        </p>
    </article>
</template>
<script>
import mappingsEn from "@/locales/en/error-map.json";
import mappingsFr from "@/locales/fr/error-map.json";
import mappingsPt from "@/locales/pt/error-map.json";
import { injectStore } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";
import { ref, computed } from "vue";

export default {
    props: {
        error: {
            default: null,
            type: String,
        },
        method: {
            default: null,
            type: String,
        },
        cardError: {
            default: null,
            type: String,
        },
        momoError: {
            default: null,
            type: String,
        },
        paymentOptions: {
            default: null,
            type: Array,
        },
        banktransferError: {
            default: null,
            type: String,
        },
    },
    setup(props) {
    // const { method, error } = toRefs(props);
    // const injectedCardError = inject("cardError", "");

        function logErrors(errorPayload) {
            const store = injectStore("");
            store.LogUntranslatedErrors.logError(errorPayload);
        }

        function checkError(description, method) {
            const store = injectStore();
            const checkoutData = ref(store.getState());
            const locale = ref(
                getValueFromPath(
                    checkoutData.value,
                    "locale",
                ) || "en",
            );

            const currency = ref(
                getValueFromPath(
                    checkoutData.value,
                    "currency.current",
                ) || null,
            );

            const isFrancoCountry = () => {
                switch (currency.value) {
                case "XAF":
                case "XOF":
                case "CFA":
                case "BRL":
                case "AOA":
                case "CVE":
                case "MZN":
                case "STN":
                case "USD":
                case "EUR":
                case "GBP":
                    return true;
                default:
                    return false;
                }
            };

            // for ( let i = 0; i < arr.length; i++ ) {
            //   if(arr[i].method == method &&  Object.keys(arr[i]).includes(description)){
            //     console.log(arr[i])
            //    console.log(arr[i][description])

            const mappings = locale.value === "en" ? mappingsEn : locale.value === "fr" ? mappingsFr : mappingsPt;
            const data = mappings.find(
                (e) => e.method == method && Object.keys(e).includes(description.toLowerCase()),
            );

            if (data == undefined || data.length < 1) {
                const fromCharge = getValueFromPath(checkoutData.value, "info.fromCharge") || null;
                if (
                    !fromCharge && !description.includes("init.") && 
                    !["network.failed.error", "network.fetch.error"].includes(description) && 
                    !description.startsWith("dynamic.") &&
                    !description.includes("limit.") &&
                    !description.includes("payment.") &&
                    !description.includes("ussd.") &&
                    isFrancoCountry() &&
                    locale.value === "fr"
                ) {
                    logErrors({ message: description });
                }

                return description;
            }

            // console.log(data[description.toLowerCase()]);
            return data[description.toLowerCase()];
        }

        const errorStyle = computed(() => {
            let style;
            if (payError.value != null) {
                const split = payError.value.split(" ");
                if (split.length > 5) {
                    style = "max__words";
                }
                else {
                    style = "min__words";
                }
            }
            return style;
        });

        const payError = computed(() => {
            let errorMessage = null;
            // if (props.cardError !== "" && props.method == "card") {
            //     cardError = props.cardError;
            // }
            // if (props.error != null) {
            //     errorMessage = checkError(props.error, props.method);
            // }
            // else if (props.error == null) {
            //     errorMessage = cardError;
            // }

            if (props.error != null) {
                errorMessage = checkError(props.error, props.method);
            }
            else if (
                props.cardError !== "" && 
                props.method === "card" &&
                (props.error !== null || props.error === null )
            ) {
                errorMessage = props.cardError;
            }
            else if (
                props.momoError !== "" && props.method &&
                (props.method === "mpesa" || props.method.includes("mobilemoney")) &&
                (props.error !== null || props.error === null )
            ) {
                errorMessage = props.momoError;
            }
            else if (
                props.banktransferError !== "" && 
                props.method === "banktransfer" &&
                (props.error !== null || props.error === null )
            ) {
                errorMessage = props.banktransferError;
            }
            else if (props.paymentOptions && props.paymentOptions?.length === 0) {
                errorMessage = "inactive.payment.error";
            }
            return errorMessage;
        });
        return {
            payError,
            errorStyle,
        };
    },
    methods: {
        translateError(){
            if(!this.payError){
                return;
            }
            const splitError = this.payError.split(" ");
            if(splitError.length === 1) {
                return this.translate(this.payError);
            }
            const newArr = splitError.map(el => {
                if (el.startsWith("dynamic.")) {
                    return this.translate(el);
                }
                return el;
            });
            return newArr.join(" ");
        },
    },
};
</script>
<style lang="scss" scoped>
.error__alert {
  width: 100%;
  background: #fff1f1;
  border: 1px solid rgba(132, 0, 0, 0.17);
  border-radius: 0.2rem;
  /* text-align: center; */
  padding: 1rem 0.8rem;
  color: #eb5757;
  display: flex;
  margin-bottom: 2.4rem;
  font-size: 1.4rem;
  line-height: 1.8rem;
  p {
  }
  &-icon {
    
  }

    @media screen and (max-width: $breakpoint-middle - 1 * 1px) {
        // margin-left: 2.3rem;
        // margin-right: 2.3rem;
    }
}

.max__words {
  p {
    width: 95%;
    margin-left: 10px;
  }
  .icon-wrapper {
    width: 5%;
  }
}

.min__words {
  justify-content: center;
  p {
      margin-left: 1rem;
  }
  .icon-wrapper {
  }
}
</style>